var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.982 2.429h-4.054V1.82C10.928.815 10.15 0 9.19 0H6.874c-.96 0-1.738.815-1.738 1.821v.608H1.082c-.32 0-.58.271-.58.607 0 .335.26.607.58.607h.63L2.82 16.448a.59.59 0 00.579.552h9.266a.59.59 0 00.58-.552l1.107-12.805h.63c.32 0 .579-.272.579-.607a.594.594 0 00-.58-.607zm-8.687-.607c0-.335.259-.607.579-.607H9.19c.32 0 .58.272.58.607v.607H6.295v-.607zm-.539 12.75h.003a.599.599 0 00.535-.651l-.579-8.5a.59.59 0 00-.62-.564.6.6 0 00-.538.65l.58 8.5a.591.591 0 00.578.564h.041zm2.855-.607c0 .335-.26.607-.58.607a.594.594 0 01-.579-.607v-8.5c0-.336.26-.608.58-.608.32 0 .579.272.579.608v8.5zm2.316.042l.579-8.5a.6.6 0 00-.538-.65.59.59 0 00-.62.564l-.58 8.5v.003a.598.598 0 00.538.647h.042a.591.591 0 00.579-.564z",
    fill: "#24425B"
  })));
}
export default __webpack_public_path__ + "static/media/trash.9d05183b.svg";
export { SvgTrash as ReactComponent };